import React, { useEffect, useState } from "react";
import { Box, CircularProgress, FormControlLabel, Grid, Radio, Typography } from "@mui/material";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CongratsModal from "../CongratsModal";
import CustomButton from "../Common/CustomButton";
import TextInput from "../Common/TextInput";
import { BASE_URL } from "../../Assets/Constants";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useCart } from "../../Services/CartContext";
import { toast } from "react-toastify";
import { theme } from "../../Assets/Theme/theme";

const stripePromise = loadStripe("pk_test_51L8KYmLRcazkgCpcN7rVeC6iJWNQq7CrRDSii4qJnYPiZmDWHRo8SqdiZVoZn8pQqt2FV985lzgzyBAf2owdAsAZ00bfbUtQME");

function PaymentForm({ data, step2Data }) {
  console.log(data, "DATA");
  
  const navigate = useNavigate();
  const { cart, setCart } = useCart();
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const token = loginData?.token

  const stripe = useStripe();
  const elements = useElements();
  const [formData, setFormData] = useState({
    name: step2Data?.name || loginData?.user?.user || "",
    email: step2Data?.email || loginData?.user?.email || "",
    phoneNumber: step2Data?.phone || "",
  });

  const [agreedTerms, setAgreedTerms] = useState(false);
  const [agreedPrivacy, setAgreedPrivacy] = useState(false);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cardDetailsComplete, setCardDetailsComplete] = useState(false);

  const fetchProfile = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/user/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.success) {
        setFormData({
          name: response.data.data.user || "",
          email: response.data.data.email || "",
        });
      }
    } catch (error) {
      console.error("Error fetching profile:", error?.response?.data);
      toast.error("Failed to load profile data.");
    } finally {
    }
  };

  useEffect(() => {
    token && fetchProfile();
  }, []);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handlePayment = async () => {
    if (!stripe || !elements) return;
  
    const cardElement = elements.getElement(CardElement);
    const userId = loginData?.user?._id || "guest"; 
  
    setLoading(true);
  
    const id = data?.bookingData?.data?._id || data?.data?._id;
  
    try {
      const { paymentMethod, error } = await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
        billing_details: {
          name: formData.name,
          email: formData.email,
          phone: formData.phoneNumber,
        },
      });
  
      if (error) {
        throw error;
      }
  
      const formattedExpiryDate = `${String(paymentMethod.card.exp_month).padStart(2, "0")}/${String(
        paymentMethod.card.exp_year
      ).slice(2)}`;
  
      const transactionData = {
        bookingData: data,
        formData: formData,
        cardDetails: {
          cardNumber: `${paymentMethod.card.last4}`,
          cardHolderName: formData.name,
          expiryDate: formattedExpiryDate,
          cvv: "****",
        },
        transactionData: {
          data: paymentMethod,
        },
      };

      console.log(transactionData, "TRANSACTION DATA");
      
      await axios.post(`${BASE_URL}/user/booking/${id}/step3`, transactionData);
  
      setCart((prev) => {
        let updatedCart = { ...prev };
  
        if (updatedCart[userId]) {
          updatedCart[userId] = updatedCart[userId].filter(
            (cartItem) => cartItem.experienceData._id !== data?.data?.experienceId
          );
  
          if (updatedCart[userId].length === 0) {
            delete updatedCart[userId]; 
          }
        }
  
        if (userId === "guest") {
          localStorage.removeItem("cart");
        } else {
          localStorage.setItem("cart", JSON.stringify(updatedCart)); 
        }
  
        return updatedCart;
      });
  
      setOpen(true); 
    } catch (error) {
      console.error("Payment failed:", error?.response || error);
      toast.error(error?.message || "Payment failed. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  };
  

  const isFormValid =
    Object.values(formData).every((field) => field.trim() !== "") &&
    agreedTerms &&
    agreedPrivacy &&
    cardDetailsComplete;

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter" && isFormValid) {
        handlePayment();
      }
    };

    window.addEventListener("keypress", handleKeyPress);

    return () => {
      window.removeEventListener("keypress", handleKeyPress);
    };
  }, [formData, isFormValid]);

  return (
    <Box sx={{ width: { xs: "100%", md: "60%" } }}>
      <Typography sx={{ fontWeight: "700", fontSize: "24px" }} gutterBottom>
        Payment Method
      </Typography>
      <FormControlLabel
        control={
          <Radio
            checked
            sx={{
              color: "orange",
              "&.Mui-checked": { color: "orange" },
            }}
          />
        }
        label="Stripe"
      />
      <Typography sx={{ fontWeight: "700", fontSize: "24px", marginBottom: 2 }}>
        Enter Your Card Details
      </Typography>
      <Box component="form" sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <TextInput
          label="Name"
          placeholder="Doe"
          value={formData.name}
          onChange={(e) => handleChange("name", e.target.value)}
        />
        <TextInput
          label="Email"
          placeholder="example@gmail.com"
          value={formData.email}
          onChange={(e) => handleChange("email", e.target.value)}
        />
        {/* <TextInput
          label="Phone Number"
          placeholder="Enter your phone number"
          value={formData.phoneNumber}
          onChange={(e) => handleChange("phoneNumber", e.target.value)}
        /> */}
        <TextInput
          label="Phone Number"
          placeholder="Enter Your Phone Number"
          type="tel"
          name="phone"
          onChange={(e) => handleChange("phoneNumber", e.target.value)}
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={10}
          value={formData.phoneNumber || ""}
        />
        <Typography>Card Details</Typography>
        <Box
          sx={{
            border: "1px solid #ccc",
            padding: 2,
            borderRadius: "4px",
          }}
        >
          <CardElement
            onChange={(e) => setCardDetailsComplete(e.complete)} 
          />

        </Box>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <div>
            <input
              type="checkbox"
              checked={agreedTerms}
              onChange={(e) => setAgreedTerms(e.target.checked)}
            />{" "}
            I agree to the{" "}
            <a style={{ color: "orange" }} href="/terms">
              Terms & Conditions
            </a>
          </div>
          <div>
            <input
              type="checkbox"
              checked={agreedPrivacy}
              onChange={(e) => setAgreedPrivacy(e.target.checked)}
            />{" "}
            I agree to the{" "}
            <a style={{ color: "orange" }} href="/privacy">
              Privacy Policy
            </a>
          </div>
        </div>
        <CustomButton onClick={handlePayment} disabled={!isFormValid || loading}>
          {loading ? <CircularProgress size={25} sx={{ color: theme.colors.white }} /> : "Pay"}
        </CustomButton>
      </Box>
      <CongratsModal handleClose={() => setOpen(false)} open={open} />
    </Box>
  );
}

export default function PaymentDetails(props) {
  return (
    <Elements stripe={stripePromise}>
      <PaymentForm {...props} />
    </Elements>
  );
}

